import { memo } from "react";

/**
 * The Novi lattice mark in white, worn by every tile in the application
 * switcher against that product's accent fill.
 *
 * Ported verbatim from novi-apps' `@novi/design` `LogoNoviMarkWhite`. White is
 * fixed rather than `currentColor`: the mark always sits on a saturated product
 * colour, never on the page background, so it does not follow the theme.
 */
function IconNoviMarkWhite({ size = 24, className = undefined }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 152 152"
      fill="none"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M146.512 34.8398C146.256 34.4797 145.938 34.1574 145.544 33.93L100.026 7.67763C99.077 7.13268 97.8485 7.13268 96.895 7.67763C95.9274 8.2368 95.3297 9.27457 95.3297 10.3882V57.4765L54.5073 33.93C53.5586 33.385 52.33 33.385 51.3766 33.93L5.86294 60.1823C4.89527 60.7368 4.29285 61.7793 4.29285 62.8929V115.398C4.29285 115.679 4.32921 115.952 4.40195 116.217C4.6154 117.004 5.13719 117.691 5.8582 118.103L5.86294 118.108L51.3719 144.36C51.8462 144.635 52.3917 144.782 52.942 144.782C53.4969 144.782 54.0377 144.635 54.5073 144.365C55.475 143.806 56.0774 142.768 56.0774 141.655V94.5663L96.8903 118.103C96.8934 118.106 96.895 118.108 96.895 118.108L142.409 144.36C142.883 144.635 143.424 144.782 143.979 144.782C144.529 144.782 145.075 144.635 145.544 144.365C146.512 143.806 147.109 142.768 147.109 141.655V89.1452V36.6405C147.109 35.9818 146.882 35.3611 146.512 34.8398ZM95.3297 68.3187V109.976L59.2128 89.1452L95.3297 68.3187ZM56.0774 83.7289V42.0711L92.1942 62.8976L56.0774 83.7289ZM101.596 68.3234L137.713 89.15L101.596 109.981V68.3234ZM49.8113 83.7289L13.6944 62.9023L49.8113 42.0711V83.7289ZM10.559 68.3234L46.6758 89.1547L10.559 109.981V68.3234ZM140.843 83.7336L104.727 62.9023L140.843 42.0758V83.7336ZM101.596 57.4765V15.8187L137.713 36.65L131.247 40.3793L101.596 57.4765ZM13.6944 115.407L49.8113 94.5757V136.234L13.6944 115.407ZM104.727 115.407L140.843 94.5805V136.238L104.727 115.407Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.01648 55.7659C3.59556 55.7659 0 59.3625 0 63.779C0 68.1955 3.59556 71.7921 8.01648 71.7921C12.4421 71.7921 16.0377 68.1955 16.0377 63.779C16.0377 59.3625 12.4421 55.7659 8.01648 55.7659Z"
        fill="#FEFEFE"
      />
      <path
        d="M52.942 81.1368C48.521 81.1368 44.9255 84.7287 44.9255 89.1452C44.9255 93.5616 48.521 97.1583 52.942 97.1583C57.3676 97.1583 60.9679 93.5616 60.9679 89.1452C60.9679 84.7287 57.3676 81.1368 52.942 81.1368Z"
        fill="#FEFEFE"
      />
      <path
        d="M98.4604 54.8797C94.0394 54.8797 90.4391 58.4764 90.4391 62.8928C90.4391 67.3093 94.0394 70.906 98.4604 70.906C102.881 70.906 106.482 67.3093 106.482 62.8928C106.482 58.4764 102.881 54.8797 98.4604 54.8797Z"
        fill="#FEFEFE"
      />
      <path
        d="M98.4604 107.389C94.0394 107.389 90.4391 110.981 90.4391 115.398C90.4391 119.819 94.0394 123.411 98.4604 123.411C102.881 123.411 106.482 119.819 106.482 115.398C106.482 110.981 102.881 107.389 98.4604 107.389Z"
        fill="#FEFEFE"
      />
      <path
        d="M52.942 28.6321C48.521 28.6321 44.9255 32.224 44.9255 36.6405C44.9255 41.0617 48.521 44.6536 52.942 44.6536C57.3676 44.6536 60.9679 41.0617 60.9679 36.6405C60.9679 32.224 57.3676 28.6321 52.942 28.6321Z"
        fill="#FEFEFE"
      />
      <path
        d="M143.979 81.1368C139.553 81.1368 135.958 84.7287 135.958 89.1452C135.958 93.5616 139.553 97.1583 143.979 97.1583C148.4 97.1583 152 93.5616 152 89.1452C152 84.7287 148.4 81.1368 143.979 81.1368Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.01648 107.389C3.59556 107.389 0 110.981 0 115.398C0 119.819 3.59556 123.411 8.01648 123.411C12.4421 123.411 16.0377 119.819 16.0377 115.398C16.0377 110.981 12.4421 107.389 8.01648 107.389Z"
        fill="#FEFEFE"
      />
      <path
        d="M52.942 133.641C48.521 133.641 44.9255 137.233 44.9255 141.655C44.9255 146.071 48.521 149.663 52.942 149.663C57.3676 149.663 60.9679 146.071 60.9679 141.655C60.9679 137.233 57.3676 133.641 52.942 133.641Z"
        fill="#FEFEFE"
      />
      <path
        d="M143.979 44.6536C148.4 44.6536 152 41.0617 152 36.6405C152 32.224 148.4 28.6321 143.979 28.6321C139.553 28.6321 135.958 32.224 135.958 36.6405C135.958 41.0617 139.553 44.6536 143.979 44.6536Z"
        fill="#FEFEFE"
      />
      <path
        d="M98.4604 2.375C94.0394 2.375 90.4391 5.97166 90.4391 10.3881C90.4391 14.8046 94.0394 18.4012 98.4604 18.4012C102.881 18.4012 106.482 14.8046 106.482 10.3881C106.482 5.97166 102.881 2.375 98.4604 2.375Z"
        fill="#FEFEFE"
      />
      <path
        d="M143.979 133.641C139.553 133.641 135.958 137.233 135.958 141.655C135.958 146.071 139.553 149.663 143.979 149.663C148.4 149.663 152 146.071 152 141.655C152 137.233 148.4 133.641 143.979 133.641Z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

export default memo(IconNoviMarkWhite);
